import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import customConfirmationHelene from "../../../../src/content/hurricane/customConfirmationDonation";
import styles from "../../../../src/content/hurricane/hurricane.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationHelene,
  styles,
  React
};